module.exports = __webpack_public_path__ + "img/Rolling-1s-200px.3e466c37.svg";